import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

const Boost = () => {
    const [users, setUsers] = useState([{ id: 0, name: "Načítám..." }]);
    const [newId, setNewId] = useState('');
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        fetch("https://api.fantasyworldtrpg.cz/echo/get_boosted_users.php")
            .then(res => res.json())
            .then(data => {
                if (data.status === 'success') {
                    setUsers(data.users);
                }
            });
    }, [refresh]);

    const addBoost = async () => {
        if (!newId.trim()) return;
        await fetch("https://api.fantasyworldtrpg.cz/echo/add_boost.php", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: newId })
        });
        setNewId('');
        setRefresh(prev => !prev);
        MySwal.fire({
            icon: 'success',
            title: 'Uživatel přidán'
        });
    };

    const removeBoost = async (id) => {
        await fetch("https://api.fantasyworldtrpg.cz/echo/remove_boost.php", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        });
        setRefresh(prev => !prev);
        MySwal.fire({
            icon: 'success',
            title: 'Uživatel odebrán'
        });
    };

    return (
        <div className="container my-5 py-5">
            <h3>Boost nastavení</h3>
            <div className="mb-4">
                <label>Zadej ID uživatele:</label>
                <div className="d-flex">
                    <input
                        type="number"
                        className="form-control me-2"
                        value={newId}
                        onChange={(e) => setNewId(e.target.value)}
                        placeholder="Např. 17"
                    />
                    <button className="btn btn-danger" onClick={addBoost}>Přidat Boost</button>
                </div>
            </div>
            <h5>Uživatelé s boostem</h5>
            <ul className="list-group">
                {users.map(user => (
                    <li key={user.id} className="list-group-item d-flex justify-content-between align-items-center">
                        <span>{user.name} (ID: {user.id})</span>
                        <button className="btn btn-sm btn-outline-danger" onClick={() => removeBoost(user.id)}>Odebrat</button>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Boost;
